import { type Car } from '@prisma/client'
import { Link } from '@remix-run/react'
import { type ZodNumberDef } from 'zod'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.js'
import ChevronRightButton from '#app/shared/ui/utils/ChevronRightButton.js'
import { cn } from '../../../lib/misc'
import { CarDescriptionMobile } from './CarDescriptionMobile'
import CarPriceCard from './CarPriceCard'

type carProps = {
  name: 'Destacados' | 'También te puede interesar' | 'Vistos recientemente'
  cars: (Car & {
    brand: { name: string }
    images: { id: string }[]
    score?: ZodNumberDef
  })[]
  isLoading?: boolean
  className?: string
}

export default function CarDescription({
  name,
  cars,
  isLoading = false,
  className,
}: carProps) {
  const slides = cars.map((car) => (
    <CarPriceCard key={car.id} car={car as any} />
  ))

  return (
    <MainContainer className={cn('', className)}>
      {name === 'Destacados' ? (
        <>
          <div className="mt-1 flex items-center justify-between">
            <p
              className={`
                text-h5-bold text-neutral-900

                lg:text-h3
              `}
            >
              Elije tu próximo coche
            </p>
            <Link to="/destacados">
              <ChevronRightButton />
            </Link>
          </div>
          <Spacer size="12px" />
        </>
      ) : (
        <p className="mb-[23px] text-h5-bold text-neutral-900">{name}</p>
      )}

      <CarDescriptionMobile slides={slides} isLoading={isLoading} />
    </MainContainer>
  )
}
